import { motion } from "framer-motion";
import { MoreHorizontal } from "lucide-react";
import element1 from "../assets/svg/element-1.svg";
import element2 from "../assets/svg/element-2.svg";
import element3 from "../assets/svg/element-3.svg";

const testimonials = [
  {
    quote: "MarketMind has transformed our approach to market analysis. Its intuitive interface and real-time data insights have significantly improved our decision-making process. Highly recommended",
    author: "Rajesh Deshmukh",
    location: "Pune, Maharashtra",
    svg: element1,
  },
  {
    quote: "As a small business owner, it is a game-changer for me. The platform's comprehensive market trends and consumer behavior analysis have provided us with a competitive edge.",
    author: "Sunita Patil",
    location: "Ahmednagar, Maharashtra",
    svg: element2,
  },
  {
    quote: "MarketMind has exceeded expectations. The real-time data processing and actionable insights have streamlined our decision-making process.",
    author: "Vikram Kulkarni",
    location: "Nashik, Maharashtra",
    svg: element3,
  },
];

export function Testimonials() {
  return (
    <section className="w-full py-12 md:py-24 px-4 bg-[#F6F6F6] overflow-visible">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 relative overflow-visible mb-12 md:mb-20">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-3xl md:text-4xl lg:text-5xl font-bold text-black mb-8 md:mb-16"
          style={{
            fontFamily: "Roboto, sans-serif",
            fontSize: "clamp(24px, 5vw, 38px)",
            lineHeight: "1.3",
          }}
        >
          Client Success Stories
        </motion.h2>

        {/* Testimonial Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-6 lg:gap-8 xl:gap-12 relative overflow-visible">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50, scale: 0.9 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              whileHover={{
                scale: 1.05,
                rotateX: 10,
                rotateY: 10,
                boxShadow: "0px 15px 25px rgba(0, 0, 0, 0.3)",
              }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="border-2 border-[#2D2543] rounded-[16px] relative bg-[#F6F6F6] shadow-lg overflow-visible perspective-1000"
            >
              <div className="bg-[#BDE9FB] p-[4px] border-b-4 border-[#2D2543] flex items-center justify-start pl-[10px] rounded-t-[16px]">
                <MoreHorizontal className="h-[24px] w-[24px] md:h-[32px] md:w-[32px] text-[#2D2543]" />
              </div>

              <div className="p-4 flex flex-col h-[300px] md:h-[350px] lg:h-[400px] w-full">
                <blockquote className="flex-grow">
                  <p className="text-black text-base md:text-lg font-semibold leading-relaxed pl-2 md:pl-4 pt-2 md:pt-3">
                    "{testimonial.quote}"
                  </p>
                </blockquote>
                <div className="mt-4 flex justify-end items-end">
                  <div className="text-right space-y-1 pb-4 md:pb-8">
                    <p className="font-semibold text-black text-sm md:text-base">
                      {testimonial.author},
                    </p>
                    <p className="text-black font-semibold text-sm md:text-base">
                      {testimonial.location}
                    </p>
                  </div>
                </div>
              </div>

              <div className="absolute -bottom-8 -left-8 sm:-bottom-10 sm:-left-10 md:-bottom-12 md:-left-12 lg:-bottom-14 lg:-left-14 w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 lg:w-40 lg:h-40 z-30 pointer-events-none">
                <motion.img
                  src={testimonial.svg}
                  alt={`Decorative element ${index + 1}`}
                  className="object-contain w-full h-full"
                />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
